<!-- <template>
	<InvoiceTemplateForm v-model="invoiceForm" />
</template> -->
<script>
	import formBase from '@_system/components/base/form.vue'
	import {
		InvoiceTemplateForm
	} from '@zhouhaiyang0326/invoicetemplateform'
	import '@zhouhaiyang0326/invoicetemplateform/dist/style.css'
	import bankaccount from '@/components/formcomponents/common/select/bankaccount/select.vue'


	import sellerBox from './box/seller.vue'
	import tradeBox from './box/trade.vue'

	export default {
		extends: formBase,
		name: 'universalinvoiceForm',
		props: {

		},
		render(h) {
			this.$slots.customForm = [ < InvoiceTemplateForm
				ref = "invoiceForm"
				v-model = {
					this.invoiceForm
				}
				actions = {
					this.invoiceActions
				}
				projectTypeOptions = {
					this.projectTypeOptions
				}
				sellerActions = {
					this.sellerActions
				}
				fieldPermissions = {
					this.fieldPermissions
				}
				detailTables = {
					this.detailTables
				}
				topInfoFields = {
					this.topInfoFields
				}
				invoice-info-fields= {
					this.invoiceInfoFields
				}
				tax-rate-options-by-invoice-type={
					this.taxRateOptionsByInvoiceType
				}
				on-button-click = {
					this.buttonClick
				}
				on-field-change = {
					this.fieldChange
				}
				on-detail-field-change = {
					this.detailFieldChange
				}
				/>
			]
			this.$slots.plug = [ <seller-box ref = "sellerBox"
				onSubmit = {
					this.sellerBoxSubmit
				}
				/>, <trade-box ref = "tradeBox"
				onSubmit = {
					this.tradeBoxSubmit
				}
				/>
			]
			return formBase.render.call(this, h)
		},
		data() {
			return {
				defaultFormShow: false,
				handle: null,
				invoiceForm: {},
				fieldPermissions: {},
				detailTables: {},
				topInfoFields: [],
				getcargotyperesultTimes:0,
				invoiceInfoFields: [
					{
						field: 'contractNo',
						label: '合同编号',
						type: 'input',
						permissions: 'required',
					},
					{
						field: 'settlementType',
						label: '结算方式',
						type: 'select',
						permissions: 'edit',
						value: 'MONTHLY',
						options: [{
								value: 'MONTHLY',
								label: '月结'
							},
							{
								value: 'CASH',
								label: '现结'
							},
						],
					},
					{
						field: 'orderSource',
						label: '订单来源',
						type: 'text',
						permissions: 'readonly',
						value: '线上订单',
					},
				]
			}

		},

		watch: {

		},
		computed: {
			invoiceActions() {
				return [{
					name: '选择订单', // 按钮名称
					type: 'primary', // 按钮样式类型
					code: 'selectOrder', // 按钮业务编码
				}]
			},
			sellerActions() {
				return [{
					name: '选择销方', // 按钮名称
					type: 'primary', // 按钮样式类型
					code: 'selectSeller', // 按钮业务编码
				}]
			},
			taxRateOptionsByInvoiceType() {
				return {
					'01': [{
						value: 0.13,
						label: '13%'
					}, ],
					'02': [{
							value: 0.01,
							label: '1%'
						},
						// {
						// 	value: 0.03,
						// 	label: '3%'
						// },
					],
				}
			},
			projectTypeOptions(){
				let cargotype = window.systemMethods.getEmun('cargotype')
				return cargotype.map((item)=>{
					return {
						label:item.label,
						value:item.code
					}
				})
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			fieldChange(e) {
				console.log(e)
			},
			detailFieldChange(e) {
				console.log(e)
			},
			buttonClick(e) {
				if (e.code == 'selectSeller') {
					this.$refs.sellerBox.initList()
					this.$refs.sellerBox.box.alertBox()
				}
				if (e.code == 'selectOrder') {
					this.$refs.tradeBox.initList()
					this.$refs.tradeBox.box.alertBox()
				}
				if (e.code == 'getcargotype') {
					this.getcargotype()
				}
				console.log(e)
				// console.log(this.$refs.invoiceForm)
			},
			getcargotype(){
				let data = this.$refs.invoiceForm.getSelectedInvoiceDetails()
				if(!data.length){
					this.$message.error('请选择开票明细')
					return
				}
				let cargoList = data.map((item)=>{
					return item.name
				})
				this.loading = true
				this.$api.universalinvoice.cargobilling({cargoList:cargoList}).then((res)=>{
					if(res){
						this.getcargotyperesult(res)
					}else{
						this.loading = false
						this.$message.error('赋码失败')
					}
				})
			},
			getcargotyperesult(batchNum){
				this.getcargotyperesultTimes++
				this.$api.universalinvoice.cargobillingresult({batchNum:batchNum}).then((res)=>{
					if(!res){
						if(this.getcargotyperesultTimes > 10){
							this.$message.error('赋码任务执行失败')
							this.loading = false
						}else{
							setTimeout(()=>{
								this.getcargotyperesult(batchNum)
							},2000)
						}
					}else{
						this.loading = false
						this.getcargotyperesultTimes = 0
						this.invoiceForm.details.forEach((item)=>{
							let target = res.find((_item)=>{
								return _item.xmmc == item.name
							})
							if(target){
								item.projectType = target.spfwjc
								item.sphfwssflhbbm = target.sphfwssflhbbm
							}
						})
						console.log(res)
					}
				})
			},
			sellerBoxSubmit(e) {
				this.invoiceForm.xsfMc = e.data.name
				this.invoiceForm.xsfNsrsbh = e.data.taxid
				this.invoiceForm.xsfDz = e.data.address
				this.invoiceForm.xsfLxdh = e.data.phone
				this.invoiceForm.xsfKhh = e.data.bank
				this.invoiceForm.xsfYhzh = e.data.accountnumber
			},
			tradeBoxSubmit(e) {
				let param = e.data.map((item) => {
					return {
						salercpt_no: item.salercpt_no,
						shopUid: item.sys_shop,
						tradeUid: item.salercpt_uid,
						storageUid: item.storage_uid
					}
				})
				this.loading = true
				this.$api.universalinvoice.gettradedetail({
					data: param
				}).then((res) => {
					this.loading = false
					let details = res.details
					let collection = res.collection
					if (collection.length) {
						this.invoiceForm.gmfMc = collection[0].invoicetitle
						this.invoiceForm.gmfNsrsbh = collection[0].invoicetaxid
						this.invoiceForm.spfEmail = collection[0].addresseeemail
					}

					let $son_universalinvoice_order = details.map((item) => {
						return {
							orderCode: item.salercpt_no,
							productCode: item.spec_code,
							productName: item.goods_name,
							cargoname: item.cargoname,
							cargotype: item.cargotype,
							spec: item.spec1_value,
							quantity: item.tp_item_size,
							unitPrice: item.tp_price,
							amount: item.tp_payment,
						}
					})

					let $son_universalinvoice_receipts = collection.map((item) => {
						return {
							receiptCode: item.code,
							orderCode: item.ordercode,
							receiptAmount: item.orderamount,
							receiptComapny: item.payman,
							receiptAccount: item.account,
							receiptShop: item.shop,
							sourceShop: item.ordershop,
						}
					})


					// this.$refs.invoiceForm.clearAllDetails()
					details.forEach((item) => {
						this.$refs.invoiceForm.addInvoiceDetail({
							projectType: item.cargotype,
							name: item.cargoname,
							spec: item.spec1_value,
							unit: '个',
							quantity: item.tp_item_size,
							unitPrice: item.tp_price,
						})
					})

					this.invoiceForm.$son_universalinvoice_order = $son_universalinvoice_order
					this.invoiceForm.$son_universalinvoice_receipts = $son_universalinvoice_receipts


					this.$nextTick(() => {
						this.updatetoPInfoFields()
					})
					// console.log(details)
				}, () => {
					this.loading = false
					this.$message.error('查询明细失败')
				})
			},
			updatetoPInfoFields(){
				let summary = this.$refs.invoiceForm.getInvoiceSummary()
				this.topInfoFields.forEach((item)=>{
					if(item.field == 'amountWithoutTax'){
						item.value = summary.amountWithoutTax?Math.round(summary.amountWithoutTax,2):0
					}
					if(item.field == 'taxAmount'){
						item.value = summary.taxAmount?Math.round(summary.taxAmount,2):0
					}
					if(item.field == 'totalAmount'){
						item.value = summary.totalAmount?Math.round(summary.totalAmount,2):0
					}
					if(item.field == 'preInvoiceAmount'){
						item.value = summary.preInvoiceAmount?Math.round(summary.preInvoiceAmount,2):0
					}
				})
				
				
				
				console.log(summary)
			},
			parseFormPermissions(fields) {
				function getPermission(field) {
					const props = field.props || {};
					if (props.disabled === true || props.readonly === true) return "readonly";
					if (field.hidden === true) return "hidden";

					const validate = Array.isArray(field.validate) ? field.validate : field.validate ? [field.validate] :
					[];
					return validate.some(rule => rule && rule.required === true) ? "required" : "edit"
				}

				function parseFields(fieldList) {
					const result = {};
					return Array.isArray(fieldList) ? (fieldList.forEach(field => {
						if (!field || !field.field) return;
						const fieldName = field.field,
							childFields = field.props && Array.isArray(field.props.fields) ? field.props
							.fields : Array.isArray(field.children) ? field.children : [];
						if (String(fieldName).startsWith("$son")) {
							let buttons_header = []
							let buttons_body = []
							let hidden = false
							field.props.buttons.forEach((item) => {
								if (!item.disabled) {
									if (item.code == 'add') {
										buttons_header.push({
											code: 'add'
										})
									} else if (item.code == 'clear') {
										buttons_header.push({
											code: 'clear'
										})
									} else if (item.code == 'del') {
										buttons_body.push({
											code: 'delete'
										})
									} else if (item.code == 'hidden') {
										hidden = true
									} else {
										if (item.type == 'operate') {
											buttons_body.push(item)
										} else {
											buttons_header.push(item)
										}
									}
								}

							})
							if (!hidden) {
								result[fieldName] = {
									buttons: {
										header: buttons_header,
										body: buttons_body
									},
									field: fieldName,
									title: field.tablename,
									columns: parseFields(childFields)
								}
							}
						} else {
							let type = 'text'
							let options = []
							if (field.field.endsWith('time')) {
								type = 'date'
							}
							if (field.type == '$inputNumber') {
								type = 'num'
							}
							if (field.type == '$emun') {
								type = 'select'
								if (field.props.name) {
									options = window.systemMethods.getEmun(field.props.name)
								}
							}
							if (field.type == '$bankaccount') {
								type = 'select'
								if (window.systemData.bankaccount) {
									options = window.systemData.bankaccount.map((item) => {
										return {
											label: item.name,
											value: item.id
										}
									})
								}
							}
							if (field.type == '$staff') {
								type = 'select'
								if (window.systemData.staff) {
									options = window.systemData.staff.map((item) => {
										return {
											label: item.name,
											value: item.id
										}
									})
								}
							}
							result[fieldName] = {
								field: fieldName,
								label: field.title,
								type: type,
								options: options,
								permissions: getPermission(field)
							}
						}
					}), result) : result
				}
				return parseFields(fields)
			},
			beforeFormCreate(rule) {
				console.log(rule)
				let fixedFields = this.$refs.invoiceForm.getFixedFields()
				let fieldPermissions = {}
				let detailTables = {}
				let invoiceInfoFields = []
				let topInfoFields = [
					{
						field: 'shopName',
						label: '店铺名称',
						value: '',
					},
					{
						field: 'amountWithoutTax',
						label: '不含税金额(元)',
						value: 0,
					},
					{
						field: 'taxAmount',
						label: '税额(元)',
						value: 0,
					},
					{
						field: 'totalAmount',
						label: '价税合计(元)',
						value: 0,
					},
					{
						field: 'preInvoiceAmount',
						label: '预开票金额(元)',
						value: 0,
					},
					{
						field: 'receivedAmount',
						label: '收款金额(元)',
						value: 0,
					},
				]
				let result = this.parseFormPermissions(rule)
				for (let i in result) {
					if (String(i).startsWith("$son")) {
						let columns = []
						for (let j in result[i]['columns']) {
							columns.push(result[i]['columns'][j])
						}
						result[i]['columns'] = columns
					}
				}
				for (let i in result) {
					if (String(i).startsWith("$son")) {
						if (i == '$son_universalinvoice_detail') {
							let details = []
							for (let j in result[i]['columns']) {
								details[result[i]['columns'][j].field] = result[i]['columns'][j].permissions
							}
							fieldPermissions['details'] = details
							detailTables['invoice'] = result[i]
						} else {
							detailTables[i] = result[i]
						}

					} else {
						fieldPermissions[i] = result[i].permissions
					}
				}

				for (let i in result) {
					let isfixed = fixedFields.find((item)=>{
						return item == i
					})
					let istop = topInfoFields.find((item)=>{
						return item.field == i
					})
					if(!isfixed && !istop &&!String(i).startsWith("$son")){
						invoiceInfoFields.push(result[i])
					}
				}
				
				
				this.invoiceInfoFields = invoiceInfoFields	
				this.fieldPermissions = fieldPermissions
				this.detailTables = detailTables
				this.topInfoFields = topInfoFields
				console.log(result,detailTables, JSON.stringify(detailTables), fieldPermissions)
			},
			beforeRender() {
				console.log(this.sourceData)
				this.invoiceForm = this.sourceData
			},
			tableDataLoad(e) {
				this.$nextTick(()=>{
					let field = '$son_' + e.module
					if (this.aftertabledataload[field]) {
						this.aftertabledataload[field].call(this, e)
					}
					this.setdataloadstatus(field)
					if(field == '$son_universalinvoice_detail'){
						this.invoiceForm.details = e.data
					}else{
						this.invoiceForm[field] = e.data
					}
				})

				// console.log(e)
			},
			handleDetailAction() {

			},
			createSubmit(){
				let data = this.$refs.invoiceForm.getSubmitData()
				for(let i in data){
					if(i!='details' && !String(i).startsWith("$son")){
						this.fApi.setValue(i,data[i])
					}else{
						if(i == 'details'){
							this.details2son('$son_universalinvoice_detail',data[i])
						}else{
							this.details2son(i,data[i])
						}
						
					}
				}
				console.log(data)
			},
			details2son(sonname,data){
				console.log(sonname)
				let son = this.fApi.el(sonname)
				console.log(son)
				son.store.table.remove()
				let newdata = data.map((item)=>{
					let obj = {}
					for(let i in item){
						if(i!='id' && i!='_X_ROW_KEY'){
							obj[i] = item[i]
						}
					}
					return obj
				})
				newdata.forEach((item)=>{
					son.store.table.insertAt(item)	
				})
				
			}
			
			// beforeInit(next) {
			// 	next()
			// },
			// tableAdd(e) {
			// 	this.handle = e
			// },
		},
		components: {
			bankaccount,
			InvoiceTemplateForm,
			sellerBox,
			tradeBox
		}
	}
</script>